import { authenticatedAxios } from '../backend.service'
import { convertirPeriodo } from '../../common/utils/functions/periodo'
import { swapPeriodo } from '../../common/components/InputMonthYear/date.utils'

const version = 'v2'
const paths = {
  getAll: `${version}/declaraciones`,
  getIdDeclaracionBorrador: `${version}/declaraciones/getIdDeclaracionBorrador`,
  bajaDeclaracion: `${version}/declaraciones/bajaDeclaracion`,
  getDeclaracionPeriodo: `${version}/declaraciones/getDeclaracionPeriodo`,
  validatePeriodoFiscal: `${version}/declaraciones/nomina/periodo`,
  desestimarDeclaracion: `${version}/declaraciones/desestimar`,
  getMotivoRechazoDeclaracion: (id) => `${version}/declaraciones/motivo/${id}`,
  verficarRectificativa: (periodo) => `${version}/declaraciones/verficar/rectificativa/${periodo}`,
  descargarReporteDdjjExtraSuss: (id) => `${version}/declaraciones/reporte/${id}`,
}

export const getDeclaraciones = async () => {
  const response = await authenticatedAxios.get(paths.getAll)
  return response
}

export const getIdDeclaracionBorrador = async ({ contrato, usuario } = null) => {
  const response = await authenticatedAxios.get(paths.getIdDeclaracionBorrador, {
    params: { contrato, usuario },
  })
  return response
}

export const bajaDeclaracion = async ({ idNomina, usuario }) => {
  const response = await authenticatedAxios.post(
    paths.bajaDeclaracion,
    {},
    {
      params: { idNomina, usuario },
    }
  )
  return response
}

export const getDeclaracionPeriodo = async ({ idNomina }) => {
  const response = await authenticatedAxios.get(paths.getDeclaracionPeriodo, {
    params: { idNomina },
  })
  return response
}

export const validatePeriodoFiscal = async ({ periodo }) => {
  let periodoFormat = convertirPeriodo(swapPeriodo(periodo))
  const response = await authenticatedAxios.post(paths.validatePeriodoFiscal, {
    periodo: periodoFormat,
  })
  return response
}
export const desestimarNominaDeclaracion = async ({ id }) => {
  const response = await authenticatedAxios.post(paths.desestimarDeclaracion, {
    id,
  })
  return response
}

export const getMotivoRechazoDeclaracion = async ({ id }) => {
  const response = await authenticatedAxios.get(paths.getMotivoRechazoDeclaracion(id))
  return response
}

export const verificarRectificativa = async ({ periodo }) => {
  let periodoFormat = convertirPeriodo(swapPeriodo(periodo))
  const response = await authenticatedAxios.get(paths.verficarRectificativa(periodoFormat))
  return response
}

export const getReporteDdjjExtraSuss = async ({ id }) => {
  const response = await authenticatedAxios.get(paths.descargarReporteDdjjExtraSuss(id))
  return response
}
